module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAA0CAMAAADypuvZAAAAUVBMVEUAAABUYnZVYnhSY3RVYndUYndVYndVYndUV2tVYnZVYndVYndVYXdVYndVYndWYndVYXZVYndTYHNVYHVWYXZZZnNVYndUYXVWY3hUYXVVYndBb06rAAAAGnRSTlMAgGAe4HD68wzt59fFs6mPVTwoGFAUu2R3TNkbPUkAAAC/SURBVEjH7dLZCoMwEIXhaHY17naZ93/Q1iJdnGZGoRdW/G7DT2A44k9pY/TapoK7al1TwkO5InEnmAS3tOkKeCq6ZY3M4U0ulzRtBh+ylm8aCzO+4ZraAmJ7ujkb+MKkVHOBCE3NIKqKz4BQxmZACi4yA1LRRWZAyiWeAS9r8Qx4vsEz4NkezQCJj6NWIw8sr0a1eEmBNX1yRJuIQjIT+Ag/pZuKtJzRmzr5jqIeWFcUDQoYyglc6YSkB3H4hRtZhXQaDulmSgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newsCenter/home-3-fill@2x.png
// module id = uX7X
// module chunks = 44